import { Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({
  namespaced: true,
  name: "AuthLayout"
})
export default class AuthLayout extends VuexModule {
  fullScreenLoading = false;
  contentLoading = false;

  @Mutation
  updateFullScreenLoading(fullScreenLoading: AuthLayout["fullScreenLoading"]) {
    this.fullScreenLoading = fullScreenLoading;
  }

  @Mutation
  updateContentLoading(contentLoading: AuthLayout["contentLoading"]) {
    this.contentLoading = contentLoading;
  }
}
